import { render } from "./InfoSub.vue?vue&type=template&id=39b6cb36&scoped=true"
import script from "./InfoSub.vue?vue&type=script&lang=js"
export * from "./InfoSub.vue?vue&type=script&lang=js"

import "./InfoSub.vue?vue&type=style&index=0&id=39b6cb36&lang=scss&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b6cb36"]])

export default __exports__